import SectionHeading from '@/components/feature/SectionHeading';
import { collections } from '@/mocks/collections';

export default function CollectionsSection() {
  return (
    <section id="collections" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="资源合集"
          title="无修资源、里番合集与冷门补番清单一处查"
          desc="除了逐条推荐，本页还把分散的条目整理成几张合集清单。每张清单都标明了整理思路与涵盖范围，方便你按主题整体浏览，而不是一部一部去翻。"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {collections.map((c) => (
            <article
              key={c.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100 overflow-hidden"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden bg-background-200">
                <img src={c.image} alt={`${c.title}配图`} title={`${c.title}`} className="w-full h-full object-cover object-top" />
                <span className="absolute bottom-3 left-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-900 backdrop-blur">
                  收录 {c.count} 部
                </span>
              </div>
              <div className="flex flex-col flex-1 p-5">
                <h3 className="font-heading text-lg md:text-xl text-foreground-950">{c.title}</h3>
                <p className="mt-1 text-xs md:text-sm text-accent-700">{c.subtitle}</p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">{c.desc}</p>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {c.tags.map((tag) => (
                    <span key={tag} className="rounded-full bg-accent-100 px-2.5 py-1 text-xs text-accent-900">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}